import { IconDefinition } from "./types";

const arrowUp: IconDefinition = {
  iconName: "arrow-up",
  width: 448,
  height: 512,
  svgPathData:
    "M241.4 15l-17-17-17 17-185 185 33.9 33.9 17-17 127-127 0 430.1 48 0 0-430.1 127 127 17 17 33.9-33.9-17-17-168-168z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "arrow-up",
  unicode: 0xf062,
};

export { arrowUp };
